import axios from "axios";
import { endpoints, endpointsBackOffice } from "../api/endpoints";
import { API } from "./comunApi";

export const usersApi = {
  // Reset password, dont need token
  resetPassword: (params) => axios.put(endpoints.RESET_PASSWORD, params),
  // resetPassword: (params) => axios.put("http://localhost:5001/api/authenticate/resetpassword", params),

  forgotPassword: (params) => axios.put(endpoints.FORGOT_PASSWORD, params),

  getUserById: async (id) => {
    return await API.get(endpointsBackOffice.GET_USER_BY_IDUSER(id));
  },
  newUser: async (params) => {
    return await API.post(endpointsBackOffice.NEW_USER, params);
  },

  updateUserProfile: (params) => {
    API.put(endpoints.UPDATE_USER_PROFILE, params);
  },
};
